import { createDiagramFromProps } from './definitions';
import { syncActiveDiagramTheme, runWithDiagramTheme } from './theme';
import { installDiagramRebuild } from './refresh';
import { resolveEffectiveUiTokens } from '../components/nodeTheme';
var registry = {};
export function registerDiagram(type, factory) {
    registry[type] = factory;
}
export function createDiagramFromJSON(type, props, app) {
    var theme = syncActiveDiagramTheme(resolveEffectiveUiTokens(app, props), app);
    return runWithDiagramTheme(theme, function () {
        var _a;
        var registered = registry[type];
        var node = registered ? registered(props, app) : createDiagramFromProps(type, props, app);
        if (!node)
            return null;
        if ('children' in node && ((_a = node.metadata) === null || _a === void 0 ? void 0 : _a.diagramType) && !node.metadata.diagramRebuild) {
            installDiagramRebuild(node, app, function (p, a) {
                var fresh = registered ? registered(p, a) : createDiagramFromProps(type, p, a);
                if (!fresh)
                    throw new Error("Unknown diagram type: ".concat(type));
                return fresh;
            });
        }
        return node;
    });
}
export { registry };
